import { Outlet, Navigate, useLocation } from "react-router-dom";
import useAuth from "../Hooks/useAuth";

const PublicRoute = () => {
  let { auth } = useAuth();
  const location = useLocation();

  return (
    auth?.accessToken ? (
      <Navigate to="/notallowed" state={{ from: location }} replace />
    ) :
    <Outlet />
  );
};

export default PublicRoute;